import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IResourceTypesForActorResource {
  type?: string;
  isAllowed?: boolean | 'true' | 'false';
}

export interface IResourceTypesForActorResult extends IResult {
  resources?: { resource?: IResourceTypesForActorResource[] } | IResourceTypesForActorResource[];
}

export class GetActorVisibleResourceTypesRequest extends Request<{}, IResourceTypesForActorResult> {
  constructor() {
    super('actorVisibleResourceTypes', null);
  }
}
